// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
const { publicRuntimeConfig } = getConfig()

import * as Sentry from '@sentry/nextjs'
import { ReportingObserver as ReportingObserverIntegration } from '@sentry/integrations'
import getConfig from 'next/config'

// const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN
// const env: any = process.env.APP_ENV
// const version: any = process.env.NEXT_PUBLIC_VERSION

const env: any = publicRuntimeConfig.APP_ENV
const version: any = publicRuntimeConfig.NEXT_PUBLIC_VERSION
const SENTRY_DSN =
    publicRuntimeConfig.SENTRY_DSN || publicRuntimeConfig.NEXT_PUBLIC_SENTRY_DSN

const sentryVersion = !version ? 'unknown' : version

if (env !== 'local') {
    Sentry.init({
        dsn:
            SENTRY_DSN ||
            'https://fae3c8f666c7490090c57f3900276878@o532609.ingest.sentry.io/6288589',
        // Adjust this value in production, or use tracesSampler for greater control
        tracesSampleRate: 1.0,
        normalizeDepth: 10,
        // integrations: [new Integrations.BrowserTracing()], // [new Integrations.BrowserTracing()],
        integrations: [new ReportingObserverIntegration()],
        debug: env === 'production' ? false : true,
        environment: env,
        release: 'custodian-public-frontend@' + sentryVersion,

        // Note: if you want to override the automatic release value, do not set a
        // `release` value here - use the environment variable `SENTRY_RELEASE`, so
        // that it will also get attached to your source maps
    })
}
